export default __webpack_public_path__ + "static/X09-5b655ebc4ba454e51b7e90b63433725b.png";